/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { apiDel, apiGet, apiPost, apiPut } from "../utils/api";
import { Colors } from "../utils/utils.colors";
import { toast } from "react-toastify";
import {
  FiPlus,
  FiCheckCircle,
  FiXCircle,
  FiEdit2,
  FiTrash2,
  FiMail,
  FiUsers,
  FiClock as FiClockI,
  FiUserPlus,
  FiFileText,
  FiLayers,
  FiBook,
  FiList,
  FiHelpCircle,
  FiTag,
  FiTrendingUp,
  FiActivity,
  FiCalendar,
  FiRefreshCcw,
} from "react-icons/fi";
import { ADMIN_BASE } from "../components/AdminLayout";
import { AdminFacultyModal } from "../components/admin/AdminFacultyModal";
import { AdminFaqModal } from "../components/admin/AdminFaqModal";
import { AdminUserModal } from "../components/admin/AdminUserModal";
import { AdminContentModal, ContentType } from "../components/admin/AdminContentModal";
import { AdminScheduleModal } from "../components/admin/AdminScheduleModal";
import { AdminCenterModal } from "../components/admin/AdminCenterModal";
import { AdminTenderModal } from "../components/admin/AdminTenderModal";
import { AdminStaffModal } from "../components/admin/AdminStaffModal";
import { AdminSpecialProgramModal } from "../components/admin/AdminSpecialProgramModal";
import { AdminKeyFactModal } from "../components/admin/AdminKeyFactModal";
import { AdminPartnerModal } from "../components/admin/AdminPartnerModal";
import { AdminAdmissionGuidePanel } from "../components/admin/AdminAdmissionGuidePanel";
import { AdminBroadcastModal } from "../components/admin/AdminBroadcastModal";
import { AdminFeesPanel } from "../components/admin/AdminFeesPanel";
import { isTenderContent } from "../utils/tenders";
import { useLanguage } from "../contexts/LanguageContext";
import {
  AdminLoadingView,
  AdminStatCard,
  AdminStatusBadge,
  AdminPageHeader,
  AdminBtnPrimary,
  AdminBtnIcon,
  AdminPanel,
  AdminDataRow,
  AdminEmptyState,
  AdminCrudPage,
  AdminBtnPrimaryRefresh,
} from "../components/admin/AdminUI";

const I = (C: any) => C as any;
const PlusI = I(FiPlus);
const Refresh = I(FiRefreshCcw);
const CheckI = I(FiCheckCircle);
const XI = I(FiXCircle);
const EditI = I(FiEdit2);
const TrashI = I(FiTrash2);
const MailI = I(FiMail);
const UsersI = I(FiUsers);
const ClockI = I(FiClockI);
const UserPlusI = I(FiUserPlus);
const FileTextI = I(FiFileText);
const LayersI = I(FiLayers);
const BookI = I(FiBook);
const ListI = I(FiList);
const HelpI = I(FiHelpCircle);
const TagI = I(FiTag);
const TrendI = I(FiTrendingUp);
const ActivityI = I(FiActivity);
const CalI = I(FiCalendar);

type ContentTypeLocal = ContentType;

export const AdminDashboard: React.FC = () => {
  const { user, isAdmin } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  // tab from URL
  const slug = location.pathname.replace(ADMIN_BASE, "").replace(/^\//, "") || "overview";

  const [stats, setStats] = useState<any>({});
  const [contents, setContents] = useState<any[]>([]);
  const [pending, setPending] = useState<any[]>([]);
  const [newsletters, setNewsletters] = useState<any[]>([]);
  const [messages, setMessages] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [faculties, setFaculties] = useState<any[]>([]);
  const [schedules, setSchedules] = useState<any[]>([]);
  const [staff, setStaff] = useState<any[]>([]);
  const [specialPrograms, setSpecialPrograms] = useState<any[]>([]);
  const [keyFacts, setKeyFacts] = useState<any[]>([]);
  const [partners, setPartners] = useState<any[]>([]);
  const [admissionGuide, setAdmissionGuide] = useState<any>(null);
  const [fees, setFees] = useState<ItemFrais[]>([]);
  const [visitStats, setVisitStats] = useState<any>(null);
  const [loginHistory, setLoginHistory] = useState<any[]>([]);

  // Modals
  const [contentModal, setContentModal] = useState<null | ContentTypeLocal>(null);
  const [editingContent, setEditingContent] = useState<any>(null);

  const [scheduleModal, setScheduleModal] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState<any>(null);

  const [userModal, setUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState<any>(null);

  const [centers, setCenters] = useState<any[]>([]);
  const [centerModal, setCenterModal] = useState(false);
  const [editingCenter, setEditingCenter] = useState<any>(null);

  const [facultyModal, setFacultyModal] = useState(false);
  const [editingFaculty, setEditingFaculty] = useState<any>(null);

  const [faqs, setFaqs] = useState<any[]>([]);
  const [faqModal, setFaqModal] = useState(false);
  const [editingFaq, setEditingFaq] = useState<any>(null);

  const [tenderModal, setTenderModal] = useState(false);
  const [editingTender, setEditingTender] = useState<any>(null);

  const [staffModal, setStaffModal] = useState(false);
  const [editingStaff, setEditingStaff] = useState<any>(null);

  const [programModal, setProgramModal] = useState(false);
  const [editingProgram, setEditingProgram] = useState<any>(null);

  const [keyFactModal, setKeyFactModal] = useState(false);
  const [editingKeyFact, setEditingKeyFact] = useState<any>(null);

  const [partnerModal, setPartnerModal] = useState(false);
  const [editingPartner, setEditingPartner] = useState<any>(null);

  const [broadcastModal, setBroadcastModal] = useState(false);
  const [broadcastContent, setBroadcastContent] = useState<any>(null);

  const [loading, setLoading] = useState(true);

  const CONTENT_TYPE_BY_SLUG: Record<string, ContentTypeLocal> = {
    articles: "article",
    events: "event",
    activities: "activity",
  };

  const refreshAll = async () => {
    if (!user) return;
    setLoading(true);
    try {
      const [s, all, fac, sch, cen] = await Promise.all([
        apiGet("/dashboard/stats"),
        apiGet("/contents/admin"),
        apiGet("/faculties"),
        apiGet("/schedules/admin"),
        apiGet("/centers/admin"),
      ]);
      setStats(s);
      setContents(all.rows);
      setFaculties(fac.rows);
      setSchedules(sch.rows);
      setCenters(cen.rows);
      const sp = await apiGet("/special-programs");
      setSpecialPrograms(sp.rows);
      if (isAdmin) {
        const st = await apiGet("/staff");
        setStaff(st.rows);
        const kf = await apiGet("/key-facts");
        setKeyFacts(kf.rows);
        const pn = await apiGet("/partners");
        setPartners(pn.rows);
        const [p, n, m, u, fq] = await Promise.all([
          apiGet("/contents/admin", { status: "pending" }),
          apiGet("/newsletter"),
          apiGet("/contact"),
          apiGet("/users"),
          apiGet("/faqs/admin"),
        ]);
        setPending(p.rows);
        setNewsletters(n.rows);
        setMessages(m.rows);
        setUsers(u.rows);
        setFaqs(fq.rows);

        if (slug === "visits" || slug === "overview" || slug === "") {
          try { setVisitStats(await apiGet("/visits/stats")); } catch (err) { console.error(err); }
        }
        if (slug === "login-history") {
          try { setLoginHistory((await apiGet("/auth/history", { limit: 100 })).rows); } catch (err) { console.error(err); }
        }
        if (slug === "admission-guide") {
          try { setAdmissionGuide((await apiGet("/admission-guide")).item); } catch (err) { console.error(err); }
        }
        if (slug === "academic-fees") {
          try {
            const res = await apiGet("/fees");
            setFees(Array.isArray(res?.rows) ? res.rows : []);
          } catch (err) { console.error(err); }
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshAll();
  }, [user, slug]);

  // ---------- Content ----------
  const openContentCreate = (type: ContentTypeLocal) => {
    setEditingContent(null);
    setContentModal(type);
  };
  const openContentEdit = (it: any) => {
    setEditingContent(it);
    setContentModal(it.type);
  };
  const approveContent = async (id: number) => { await apiPost(`/contents/${id}/approve`, {}); toast.success("Approuvé"); refreshAll(); };
  const rejectContent = async (id: number) => {
    const reason = prompt("Motif du rejet ?") || "Refusé";
    await apiPost(`/contents/${id}/reject`, { reason });
    toast.info("Rejeté");
    refreshAll();
  };
  const removeContent = async (id: number) => {
    if (!window.confirm("Supprimer ?")) return;
    await apiDel(`/contents/${id}`);
    refreshAll();
  };

  const tenders = contents.filter(isTenderContent);

  const contentCategories = Array.from(
    new Set(contents.map((c) => (c.category || "").trim()).filter(Boolean))
  );

  // ---------- Staff ----------
  const openStaffCreate = () => {
    setEditingStaff(null);
    setStaffModal(true);
  };
  const openStaffEdit = (it: any) => {
    setEditingStaff(it);
    setStaffModal(true);
  };
  const removeStaff = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteStaff)) return;
    try {
      await apiDel(`/staff/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || e?.messageText || t.common.error);
    }
  };

  // ---------- Special Programs ----------
  const openProgramCreate = () => {
    setEditingProgram(null);
    setProgramModal(true);
  };
  const openProgramEdit = (it: any) => {
    setEditingProgram(it);
    setProgramModal(true);
  };
  const removeProgram = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteSpecialProgram)) return;
    try {
      await apiDel(`/special-programs/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || e?.messageText || t.common.error);
    }
  };

  // ---------- Key Facts ----------
  const openKeyFactCreate = () => {
    setEditingKeyFact(null);
    setKeyFactModal(true);
  };
  const openKeyFactEdit = (it: any) => {
    setEditingKeyFact(it);
    setKeyFactModal(true);
  };
  const removeKeyFact = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteKeyFact)) return;
    try {
      await apiDel(`/key-facts/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || e?.messageText || t.common.error);
    }
  };

  const openPartnerCreate = () => {
    setEditingPartner(null);
    setPartnerModal(true);
  };
  const openPartnerEdit = (it: any) => {
    setEditingPartner(it);
    setPartnerModal(true);
  };
  const removePartner = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeletePartner)) return;
    try {
      await apiDel(`/partners/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || e?.messageText || t.common.error);
    }
  };

  const openTenderCreate = () => {
    setEditingTender(null);
    setTenderModal(true);
  };
  const openTenderEdit = (it: any) => {
    setEditingTender(it);
    setTenderModal(true);
  };

  // ---------- Schedule ----------
  const openScheduleCreate = () => {
    setEditingSchedule(null);
    setScheduleModal(true);
  };
  const openScheduleEdit = (it: any) => {
    setEditingSchedule(it);
    setScheduleModal(true);
  };
  const approveSchedule = async (id: number) => { await apiPost(`/schedules/${id}/approve`, {}); refreshAll(); };
  const rejectSchedule = async (id: number) => {
    const reason = prompt("Motif ?") || "Refusé";
    await apiPost(`/schedules/${id}/reject`, { reason }); refreshAll();
  };
  const removeSchedule = async (id: number) => {
    if (!window.confirm("Supprimer ?")) return;
    await apiDel(`/schedules/${id}`); refreshAll();
  };

  // ---------- Center ----------
  const openCenterCreate = () => {
    setEditingCenter(null);
    setCenterModal(true);
  };
  const openCenterEdit = (it: any) => {
    setEditingCenter(it);
    setCenterModal(true);
  };
  const approveCenter = async (id: number) => { await apiPost(`/centers/${id}/approve`, {}); refreshAll(); };
  const rejectCenter = async (id: number) => {
    const reason = prompt("Motif ?") || "Refusé";
    await apiPost(`/centers/${id}/reject`, { reason }); refreshAll();
  };
  const removeCenter = async (id: number) => {
    if (!window.confirm("Supprimer ?")) return;
    await apiDel(`/centers/${id}`); refreshAll();
  };

  // ---------- Faculty ----------
  const openFacultyCreate = () => {
    setEditingFaculty(null);
    setFacultyModal(true);
  };
  const openFacultyEdit = (it: any) => {
    setEditingFaculty(it);
    setFacultyModal(true);
  };
  const removeFaculty = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteFaculty)) return;
    try {
      await apiDel(`/faculties/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || t.common.error);
    }
  };

  // ---------- FAQ ----------
  const openFaqCreate = () => {
    setEditingFaq(null);
    setFaqModal(true);
  };
  const openFaqEdit = (it: any) => {
    setEditingFaq(it);
    setFaqModal(true);
  };
  const removeFaq = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteFaq)) return;
    try {
      await apiDel(`/faqs/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || t.common.error);
    }
  };

  // ---------- Users ----------
  const openUserCreate = () => {
    setEditingUser(null);
    setUserModal(true);
  };
  const openUserEdit = (u: any) => {
    setEditingUser(u);
    setUserModal(true);
  };
  const removeUser = async (id: number) => {
    if (!window.confirm(t.admin.confirmDeleteUser)) return;
    try {
      await apiDel(`/users/${id}`);
      toast.success(t.common.saveSuccess);
      refreshAll();
    } catch (e: any) {
      toast.error(e?.response?.data?.reason || e?.messageText || t.common.error);
    }
  };

  // ---------- Renderers ----------
  const openBroadcast = (it: any) => {
    setBroadcastContent(it);
    setBroadcastModal(true);
  };

  const contentRow = (it: any, scope: "content" | "schedule" = "content") => (
    <AdminDataRow
      key={`${scope}-${it.id}`}
      testId={`${scope}-row-${it.id}`}
      thumb={scope === "content" ? it.coverImage : undefined}
      actions={
        <>
          {isAdmin && it.status === "pending" && (
            <>
              <AdminBtnIcon variant="success" data-testid={`${scope}-approve-${it.id}`} onClick={() => (scope === "content" ? approveContent(it.id) : approveSchedule(it.id))} title="Approuver"><CheckI /></AdminBtnIcon>
              <AdminBtnIcon variant="danger" data-testid={`${scope}-reject-${it.id}`} onClick={() => (scope === "content" ? rejectContent(it.id) : rejectSchedule(it.id))} title="Rejeter"><XI /></AdminBtnIcon>
            </>
          )}
          {scope === "content" && isAdmin && it.status === "published" && (
            <AdminBtnIcon data-testid={`${scope}-broadcast-${it.id}`} onClick={() => openBroadcast(it)} title={t.admin.broadcastTitle || "Diffuser"}><MailI /></AdminBtnIcon>
          )}
          <AdminBtnIcon data-testid={`${scope}-edit-${it.id}`} onClick={() => (scope === "content" ? openContentEdit(it) : openScheduleEdit(it))}><EditI /></AdminBtnIcon>
          <AdminBtnIcon variant="delete" data-testid={`${scope}-delete-${it.id}`} onClick={() => (scope === "content" ? removeContent(it.id) : removeSchedule(it.id))}><TrashI /></AdminBtnIcon>
        </>
      }
    >
      <div className="admin-data-row__meta">
        <span className="admin-badge admin-badge--type">{it.type}</span>
        <AdminStatusBadge status={it.status} />
        {scope === "schedule" && it.promotion && <span className="admin-data-row__sub">{it.promotion}</span>}
        {it.category && <span className="admin-data-row__sub">{it.category}</span>}
        {it.faculty?.name && <span className="admin-data-row__sub">· {it.faculty.name}</span>}
        {it.center?.title && <span className="admin-data-row__sub">· {it.center.title}</span>}
      </div>
      <h4 className="admin-data-row__title">{it.title}</h4>
      <div className="admin-data-row__sub">
        Par {it.author?.name} · {new Date(it.createdAt).toLocaleDateString()}
        {it.academicYear && ` · ${it.academicYear}`}
      </div>
      {it.rejectionReason && <div className="admin-data-row__sub" style={{ color: Colors.redColor }}>Motif: {it.rejectionReason}</div>}
    </AdminDataRow>
  );

  const renderTab = () => {
    if (slug === "overview" || slug === "") {
      const recentArticles = contents.filter((c) => c.type === "article").slice(0, 6);
      return (
        <div className="admin-overview">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
            <div className="admin-overview__intro">
              <span className="admin-eyebrow">{t.admin.overviewEyebrow}</span>
              <h2 className="admin-overview__title">{t.admin.overviewWelcome}</h2>
              <p className="admin-overview__subtitle">{t.admin.overviewDesc}</p>
            </div>
            <AdminBtnPrimaryRefresh data-testid="overview-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          </div>

          <div className="admin-stats-grid admin-stats-grid--overview">
            {isAdmin ? (
              <>
                <AdminStatCard label={t.admin.statArticles} value={stats.articles ?? 0} Icon={FileTextI} />
                <AdminStatCard label={t.admin.statStaff} value={stats.personnel ?? 0} color="#6366f1" Icon={UsersI} />
                <AdminStatCard label={t.admin.statCenters} value={stats.centers ?? 0} color="#0ea5e9" Icon={ActivityI} />
                <AdminStatCard label={t.admin.statDomains} value={stats.domaines ?? 0} color="#8b5cf6" Icon={LayersI} />
                <AdminStatCard label={t.admin.statFaculties} value={stats.faculties ?? 0} color="#041797" Icon={BookI} />
                <AdminStatCard label={t.admin.statPrograms} value={stats.filieres ?? 0} color="#0891b2" Icon={ListI} />
                <AdminStatCard label={t.admin.statActivities} value={stats.activitiesEvents ?? 0} color="#f59e0b" Icon={CalI} />
                <AdminStatCard label={t.admin.statFaqs} value={stats.faqs ?? 0} color="#64748b" Icon={HelpI} />
                <AdminStatCard label={t.admin.statCategories} value={stats.categories ?? 0} color="#ec4899" Icon={TagI} />
                <AdminStatCard label={t.admin.statVisitors} value={visitStats?.total ?? 0} color="#10b981" Icon={TrendI} />
              </>
            ) : (
              <>
                <AdminStatCard label={t.admin.statArticles} value={stats.articles ?? 0} Icon={FileTextI} />
                <AdminStatCard label={t.admin.statActivities} value={stats.activitiesEvents ?? 0} color="#f59e0b" Icon={CalI} />
                <AdminStatCard label={t.admin.statCenters} value={stats.centers ?? 0} color="#0ea5e9" Icon={ActivityI} />
                <AdminStatCard label="En attente" value={stats.pending ?? 0} color="#f1a606" Icon={ClockI} />
                <AdminStatCard label="Publiés" value={stats.published ?? 0} color="#28a745" Icon={CheckI} />
              </>
            )}
          </div>

          <div className="admin-recent">
            <span className="admin-eyebrow">{t.admin.recentEyebrow}</span>
            <h3 className="admin-recent__title">{t.admin.recentTitle}</h3>
            <AdminPanel>
              {recentArticles.length === 0 ? (
                <AdminEmptyState message={t.admin.recentEmpty} />
              ) : (
                recentArticles.map((c) => contentRow(c))
              )}
            </AdminPanel>
          </div>
        </div>
      );
    }
    if (slug === "tenders") {
      return (
        <AdminCrudPage
          title={t.admin.tenders}
          emptyMessage={t.admin.emptyTenders}
          isEmpty={tenders.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-tender-button" onClick={openTenderCreate}>
                <PlusI /> {t.admin.newTender}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="tenders-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {tenders.map((c) => (
            <AdminDataRow
              key={`tender-${c.id}`}
              testId={`content-row-${c.id}`}
              thumb={c.coverImage}
              actions={
                <>
                  {isAdmin && c.status === "pending" && (
                    <>
                      <AdminBtnIcon variant="success" onClick={() => approveContent(c.id)} title="Approuver"><CheckI /></AdminBtnIcon>
                      <AdminBtnIcon variant="danger" onClick={() => rejectContent(c.id)} title="Rejeter"><XI /></AdminBtnIcon>
                    </>
                  )}
                  <AdminBtnIcon onClick={() => openTenderEdit(c)}><EditI /></AdminBtnIcon>
                  <AdminBtnIcon variant="delete" onClick={() => removeContent(c.id)}><TrashI /></AdminBtnIcon>
                </>
              }
            >
              <div className="admin-data-row__meta">
                <span className="admin-badge admin-badge--type">appel-offre</span>
                <AdminStatusBadge status={c.status} />
                {c.eventDate && (
                  <span className="admin-data-row__sub">
                    Échéance : {new Date(c.eventDate).toLocaleDateString("fr-FR")}
                  </span>
                )}
              </div>
              <h4 className="admin-data-row__title">{c.title}</h4>
              <div className="admin-data-row__sub">
                Par {c.author?.name} · {new Date(c.createdAt).toLocaleDateString()}
              </div>
            </AdminDataRow>
          ))}
        </AdminCrudPage>
      );
    }
    if (["articles", "events", "activities"].includes(slug)) {
      const type = CONTENT_TYPE_BY_SLUG[slug];
      const items = contents.filter((c) => c.type === type);
      return (
        <AdminCrudPage
          title={{ articles: t.admin.articlesPosts, events: t.admin.events, activities: t.admin.activitiesEvents }[slug] || slug}
          emptyMessage={t.admin.emptyContent}
          isEmpty={items.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid={`new-${type}-button`} onClick={() => openContentCreate(type)}>
                <PlusI /> {t.admin.create}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid={`${type}-refresh`} onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {items.map((c) => contentRow(c))}
        </AdminCrudPage>
      );
    }
    if (slug === "schedules") {
      return (
        <AdminCrudPage
          title={t.admin.schedulesFull}
          emptyMessage={t.admin.emptySchedules}
          isEmpty={schedules.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-schedule-button" onClick={openScheduleCreate}>
                <PlusI /> {t.admin.newSchedule}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="schedules-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {schedules.map((s) => contentRow(s, "schedule"))}
        </AdminCrudPage>
      );
    }
    if (slug === "centers") {
      return (
        <AdminCrudPage
          title={t.admin.researchCenters}
          emptyMessage={t.admin.emptyCenters}
          isEmpty={centers.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-center-button" onClick={openCenterCreate}>
                <PlusI /> {t.admin.newCenter}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="centers-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {centers.map((c) => (
            <div key={c.id} data-testid={`center-row-${c.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              {c.coverImage && <img src={c.coverImage} alt="" style={{ width: 86, height: 64, objectFit: "cover", borderRadius: 6 }} />}
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span style={{ fontSize: 11, background: Colors.darkColor, color: "white", padding: "2px 8px", borderRadius: 4 }}>CENTRE</span>
                  <AdminStatusBadge status={c.status} />
                </div>
                <h4 style={{ margin: "6px 0 4px", fontSize: 15, color: Colors.darkColor }}>{c.title}</h4>
                <div style={{ fontSize: 12, color: "#666" }}>{(c.description || "").slice(0, 100)}...</div>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                {isAdmin && c.status === "pending" && (
                  <>
                    <button onClick={() => approveCenter(c.id)} style={{ background: "#28a745", color: "white", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><CheckI /></button>
                    <button onClick={() => rejectCenter(c.id)} style={{ background: "#dc3545", color: "white", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><XI /></button>
                  </>
                )}
                <button data-testid={`center-edit-${c.id}`} onClick={() => openCenterEdit(c)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`center-delete-${c.id}`} onClick={() => removeCenter(c.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "faculties" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.faculties}
          emptyMessage={t.admin.noFaculty}
          isEmpty={faculties.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-faculty-button" onClick={openFacultyCreate}>
                <PlusI /> {t.admin.newFaculty}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="faculties-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {faculties.map((f) => (
            <div key={f.id} data-testid={`faculty-row-${f.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 11, color: Colors.redColor, fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase" }}>{f.domaine}</div>
                <h4 style={{ margin: "6px 0 4px", fontSize: 15, color: Colors.darkColor }}>{f.name}</h4>
                <div style={{ fontSize: 12, color: "#666" }}>
                  Doyen : {f.dean || "—"} · {f.filieres?.length || 0} filière(s) · /{f.slug}
                </div>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`faculty-edit-${f.id}`} onClick={() => openFacultyEdit(f)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`faculty-delete-${f.id}`} onClick={() => removeFaculty(f.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "staff" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.staff}
          emptyMessage={t.admin.emptyStaff}
          isEmpty={staff.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-staff-button" onClick={openStaffCreate}>
                <PlusI /> {t.admin.newStaff}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="staff-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {staff.map((m) => (
            <div key={m.id} data-testid={`staff-row-${m.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              {m.image ? (
                <img src={m.image} alt="" style={{ width: 56, height: 56, objectFit: "cover", borderRadius: "50%", flexShrink: 0 }} />
              ) : (
                <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#eef1f6", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: Colors.primaryColor, flexShrink: 0 }}>
                  {(m.name || "?").charAt(0)}
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <h4 style={{ margin: 0, fontSize: 15, color: Colors.darkColor }}>{m.name}</h4>
                  {m.isOrganizer && <span style={{ fontSize: 11, background: Colors.primaryColor, color: "white", padding: "2px 8px", borderRadius: 20 }}>{t.admin.staffOrganizerBadge}</span>}
                </div>
                <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>{m.role}</div>
                {Array.isArray(m.email) && m.email.length > 0 && (
                  <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{m.email.join(", ")}</div>
                )}
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`staff-edit-${m.id}`} onClick={() => openStaffEdit(m)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`staff-delete-${m.id}`} onClick={() => removeStaff(m.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "special-programs" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.specialPrograms}
          emptyMessage={t.admin.emptySpecialPrograms}
          isEmpty={specialPrograms.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-program-button" onClick={openProgramCreate}>
                <PlusI /> {t.admin.newSpecialProgram}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="programs-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {specialPrograms.map((p) => (
            <div key={p.id} data-testid={`program-row-${p.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              {p.coverImage ? (
                <img src={p.coverImage} alt="" style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
              ) : (
                <div style={{ width: 56, height: 56, borderRadius: 8, background: "#eef1f6", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, color: Colors.primaryColor, flexShrink: 0 }}>
                  {(p.name || "?").charAt(0)}
                </div>
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <h4 style={{ margin: 0, fontSize: 15, color: Colors.darkColor }}>{p.name}</h4>
                  {!p.isActive && <span style={{ fontSize: 11, background: "#e2e8f0", color: "#475569", padding: "2px 8px", borderRadius: 20 }}>{t.admin.inactive}</span>}
                </div>
                <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>{p.faculty?.name || "—"}</div>
                {p.description && <div style={{ fontSize: 12, color: "#888", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.description}</div>}
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`program-edit-${p.id}`} onClick={() => openProgramEdit(p)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`program-delete-${p.id}`} onClick={() => removeProgram(p.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "key-facts" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.keyFacts}
          emptyMessage={t.admin.noKeyFacts}
          isEmpty={keyFacts.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-keyfact-button" onClick={openKeyFactCreate}>
                <PlusI /> {t.admin.newKeyFact}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="keyfacts-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {keyFacts.map((kf, idx) => (
            <div key={kf.id} data-testid={`keyfact-row-${kf.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: Colors.primaryColor, flexShrink: 0 }}>
                {String(kf.sortOrder ?? idx + 1).padStart(2, "0")}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontSize: 12, padding: "2px 8px", borderRadius: 20, background: kf.isActive ? "#d4edda" : "#f8d7da", color: kf.isActive ? "#155724" : "#721c24" }}>
                    {kf.isActive ? t.admin.active : t.admin.inactive}
                  </span>
                </div>
                <h4 style={{ margin: "0 0 4px", fontSize: 15, color: Colors.darkColor }}>{kf.title}</h4>
                <div style={{ fontSize: 20, fontWeight: 700, color: Colors.primaryColor }}>{kf.value}</div>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`keyfact-edit-${kf.id}`} onClick={() => openKeyFactEdit(kf)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`keyfact-delete-${kf.id}`} onClick={() => removeKeyFact(kf.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "partners" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.sitePartners}
          emptyMessage={t.admin.noPartners}
          isEmpty={partners.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-partner-button" onClick={openPartnerCreate}>
                <PlusI /> {t.admin.newPartner}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="partners-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {partners.map((p) => (
            <div key={p.id} data-testid={`partner-row-${p.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "center", marginBottom: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: Colors.primaryColor, flexShrink: 0 }}>
                {String(p.sortOrder ?? 0).padStart(2, "0")}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontSize: 12, padding: "2px 8px", borderRadius: 20, background: p.isActive ? "#d4edda" : "#f8d7da", color: p.isActive ? "#155724" : "#721c24" }}>
                    {p.isActive ? t.admin.active : t.admin.inactive}
                  </span>
                </div>
                <h4 style={{ margin: "0 0 4px", fontSize: 15, color: Colors.darkColor }}>{p.name}</h4>
                {p.url && <div style={{ fontSize: 12, color: "#888" }}>{p.url}</div>}
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`partner-edit-${p.id}`} onClick={() => openPartnerEdit(p)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`partner-delete-${p.id}`} onClick={() => removePartner(p.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "faqs" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.faqs}
          emptyMessage={t.admin.noFaqs}
          isEmpty={faqs.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="new-faq-button" onClick={openFaqCreate}>
                <PlusI /> {t.admin.newFaq}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="faqs-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {faqs.map((f, idx) => (
            <div key={f.id} data-testid={`faq-row-${f.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)", display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: Colors.primaryColor, flexShrink: 0 }}>
                {String(f.sortOrder ?? idx + 1).padStart(2, "0")}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 4 }}>
                  <span style={{ fontSize: 12, padding: "2px 8px", borderRadius: 20, background: f.isActive ? "#d4edda" : "#f8d7da", color: f.isActive ? "#155724" : "#721c24" }}>
                    {f.isActive ? t.admin.active : t.admin.inactive}
                  </span>
                </div>
                <h4 style={{ margin: "0 0 6px", fontSize: 15, color: Colors.darkColor }}>{f.question}</h4>
                <p style={{ margin: 0, fontSize: 13, color: "#666", lineHeight: 1.5 }}>{(f.answer || "").slice(0, 160)}{(f.answer || "").length > 160 ? "…" : ""}</p>
              </div>
              <div style={{ display: "flex", gap: 6 }}>
                <button data-testid={`faq-edit-${f.id}`} onClick={() => openFaqEdit(f)} style={{ background: "#f0f0f0", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer" }}><EditI /></button>
                <button data-testid={`faq-delete-${f.id}`} onClick={() => removeFaq(f.id)} style={{ background: "#fde2e2", border: "none", padding: "8px 10px", borderRadius: 6, cursor: "pointer", color: Colors.redColor }}><TrashI /></button>
              </div>
            </div>
          ))}
        </AdminCrudPage>
      );
    }
    if (slug === "admission-guide" && isAdmin) {
      return (
        <>
          <AdminPageHeader title={t.admin.admissionGuide} />
          <AdminAdmissionGuidePanel item={admissionGuide} onSaved={setAdmissionGuide} />
        </>
      );
    }
    if (slug === "academic-fees" && isAdmin) {
      return (
        <>
          <AdminPageHeader title={t.admin.academicFees} subtitle={t.admin.academicFeesDesc} />
          <AdminFeesPanel rows={fees} onSaved={setFees} />
        </>
      );
    }
    if (slug === "pending" && isAdmin) {
      return (
        <AdminCrudPage 
          title={t.admin.pending} 
          emptyMessage={t.admin.emptyPending} 
          isEmpty={pending.length === 0}
          action={
            <AdminBtnPrimaryRefresh data-testid="pending-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          }
        >
          {pending.map((c) => contentRow(c))}
        </AdminCrudPage>
      );
    }
    if (slug === "newsletter" && isAdmin) {
      return (
        <AdminCrudPage 
          title={t.admin.newsletter} 
          emptyMessage={t.admin.emptyNewsletter} 
          isEmpty={newsletters.length === 0}
          action={
            <AdminBtnPrimaryRefresh data-testid="newsletter-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          }
        >
          <div className="px-4">
            {newsletters.map((n) => (
              <div key={n.id} data-testid={`newsletter-${n.id}`} style={{ padding: "8px 0", borderBottom: "1px solid #eee", display: "flex", justifyContent: "space-between" }}>
                <span>{n.email}</span>
                <span style={{ fontSize: 12, color: "#888" }}>{new Date(n.createdAt).toString()}</span>
              </div>
            ))}
          </div>
        </AdminCrudPage>
      );
    }
    if (slug === "messages" && isAdmin) {
      return (
        <AdminCrudPage 
          title={t.admin.messages} 
          emptyMessage={t.admin.emptyMessages} 
          isEmpty={messages.length === 0}
          action={
            <AdminBtnPrimaryRefresh data-testid="messages-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          }
        >
          <div className="grid gap-3">
            {messages.map((m) => (
              <div key={m.id} data-testid={`message-${m.id}`} style={{ background: "white", padding: 16, borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,0.05)" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <strong>{m.subject}</strong>
                  <span style={{ fontSize: 12, color: "#888" }}>{new Date(m.createdAt).toLocaleString()}</span>
                </div>
                <div style={{ fontSize: 13, color: "#555", marginTop: 4 }}><b>{m.name}</b> &lt;{m.email}&gt;</div>
                <p style={{ marginTop: 10, color: "#333", whiteSpace: "pre-wrap" }}>{m.message}</p>
              </div>
            ))}
          </div>
        </AdminCrudPage>
      );
    }
    if (slug === "visits" && isAdmin) {
      const vs = visitStats || {};
      const days: any[] = Array.isArray(vs.last7days) ? vs.last7days : [];
      const maxVisits = Math.max(1, ...days.map((d) => d.visits || 0));
      const topPages: any[] = Array.isArray(vs.topPages) ? vs.topPages : [];
      return (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
            <AdminPageHeader title={t.admin.visits} subtitle={t.admin.visitsSubtitle} />
            <AdminBtnPrimaryRefresh data-testid="visits-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          </div>
          <div className="admin-stats-grid admin-stats-grid--overview" style={{ marginBottom: 24 }}>
            <AdminStatCard label={t.admin.visitsTotal} value={vs.total ?? 0} Icon={TrendI} />
            <AdminStatCard label={t.admin.visitsUnique} value={vs.unique ?? 0} color="#6366f1" Icon={UsersI} />
            <AdminStatCard label={t.admin.visitsToday} value={vs.today ?? 0} color="#f59e0b" Icon={CalI} />
            <AdminStatCard label={t.admin.visitsTodayUnique} value={vs.todayUnique ?? 0} color="#0ea5e9" Icon={UsersI} />
          </div>

          <AdminPanel title={t.admin.visitsLast7Days}>
            {days.length === 0 ? (
              <AdminEmptyState message={t.admin.visitsNoData} />
            ) : (
              <div className="admin-visit-chart" data-testid="visit-chart">
                {days.map((d) => (
                  <div className="admin-visit-bar" key={d.date} title={`${d.visits} visites · ${d.unique} uniques`}>
                    <div className="admin-visit-bar__value">{d.visits}</div>
                    <div className="admin-visit-bar__track">
                      <div className="admin-visit-bar__fill" style={{ height: `${Math.round(((d.visits || 0) / maxVisits) * 100)}%` }} />
                    </div>
                    <div className="admin-visit-bar__label">
                      {new Date(d.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" })}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </AdminPanel>

          {topPages.length > 0 && (
            <div style={{ marginTop: 24 }}>
              <AdminPanel title={t.admin.visitsTopPages}>
                <div className="admin-table-wrap border-0 shadow-none">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>{t.admin.colPath}</th>
                        <th>{t.admin.colVisits}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topPages.map((p, i) => (
                        <tr key={`tp-${i}`}>
                          <td>{p.path}</td>
                          <td>{p.visits}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </AdminPanel>
            </div>
          )}
        </>
      );
    }
    if (slug === "login-history" && isAdmin) {
      const statusLabel: Record<string, string> = {
        success: t.admin.loginStatusSuccess,
        failed: t.admin.loginStatusFailed,
        disabled: t.admin.loginStatusDisabled,
      };
      const statusClass: Record<string, string> = {
        success: "active", failed: "inactive", disabled: "inactive",
      };
      return (
        <AdminCrudPage
          title={t.admin.loginHistory}
          subtitle={t.admin.loginHistorySubtitle}
          emptyMessage={t.admin.loginHistoryEmpty}
          isEmpty={loginHistory.length === 0}
          action={
            <AdminBtnPrimaryRefresh data-testid="login-history-refresh" onClick={refreshAll}>
              <Refresh /> {t.admin.refresh}
            </AdminBtnPrimaryRefresh>
          }
        >
          <div className="admin-table-wrap border-0 shadow-none">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>{t.admin.loginColUser}</th>
                  <th>{t.admin.loginColStatus}</th>
                  <th>{t.admin.loginColIp}</th>
                  <th>{t.admin.loginColDevice}</th>
                  <th>{t.admin.loginColDate}</th>
                </tr>
              </thead>
              <tbody>
                {loginHistory.map((h) => (
                  <tr key={h.id} data-testid={`login-row-${h.id}`}>
                    <td>
                      <div style={{ fontWeight: 600 }}>{h.user?.name || "—"}</div>
                      <div className="admin-data-row__sub">{h.email}</div>
                    </td>
                    <td>
                      <span className={`admin-badge admin-badge--${statusClass[h.status] || "inactive"}`}>
                        {statusLabel[h.status] || h.status}
                      </span>
                    </td>
                    <td>{h.ip || "—"}</td>
                    <td style={{ maxWidth: 260, whiteSpace: "normal", wordBreak: "break-word", fontSize: 12 }}>{h.userAgent || "—"}</td>
                    <td>{new Date(h.createdAt).toLocaleString("fr-FR")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </AdminCrudPage>
      );
    }
    if (slug === "users" && isAdmin) {
      return (
        <AdminCrudPage
          title={t.admin.users}
          emptyMessage={t.admin.emptyUsers}
          isEmpty={users.length === 0}
          action={
            <div style={{ display: "flex", gap: 8 }}>
              <AdminBtnPrimary data-testid="create-user-button" onClick={openUserCreate}>
                <UserPlusI /> {t.admin.newUser}
              </AdminBtnPrimary>
              <AdminBtnPrimaryRefresh data-testid="users-refresh" onClick={refreshAll}>
                <Refresh /> {t.admin.refresh}
              </AdminBtnPrimaryRefresh>
            </div>
          }
        >
          {users.length > 0 && (
            <div className="admin-table-wrap border-0 shadow-none">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>{t.admin.name}</th>
                    <th>{t.admin.email}</th>
                    <th>{t.admin.role}</th>
                    <th>{t.admin.faculty}</th>
                    <th>{t.admin.researchCenters}</th>
                    <th>Status</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u.id} data-testid={`user-${u.id}`}>
                      <td>{u.name}</td>
                      <td>{u.email}</td>
                      <td>
                        {u.role === "super_admin"
                          ? t.admin.roleAdmin
                          : u.role === "center_publisher"
                            ? t.admin.roleCenterPublisher
                            : t.admin.rolePublisher}
                      </td>
                      <td>{u.faculty?.name || "—"}</td>
                      <td>{u.center?.title || "—"}</td>
                      <td>
                        <span className={`admin-badge admin-badge--${u.isActive ? "active" : "inactive"}`}>
                          {u.isActive ? t.admin.active : t.admin.inactive}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button type="button" data-testid={`user-edit-${u.id}`} onClick={() => openUserEdit(u)} className="admin-btn admin-btn--icon"><EditI /></button>
                          {u.id !== user?.id && (
                            <button type="button" data-testid={`user-delete-${u.id}`} onClick={() => removeUser(u.id)} className="admin-btn admin-btn--icon admin-btn--icon--danger"><TrashI /></button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </AdminCrudPage>
      );
    }
    return <div>Page introuvable</div>;
  };

  if (loading) return <AdminLoadingView slug={slug} isAdmin={isAdmin} />;

  return (
    <div className="admin-dashboard">
      {renderTab()}

      {contentModal && (
        <AdminContentModal
          open={!!contentModal}
          type={contentModal}
          editing={editingContent}
          isAdmin={isAdmin}
          categories={contentCategories}
          specialPrograms={specialPrograms}
          onClose={() => { setContentModal(null); setEditingContent(null); }}
          onSaved={refreshAll}
        />
      )}

      <AdminScheduleModal
        open={scheduleModal}
        editing={editingSchedule}
        faculties={faculties}
        isAdmin={isAdmin}
        onClose={() => { setScheduleModal(false); setEditingSchedule(null); }}
        onSaved={refreshAll}
      />

      <AdminCenterModal
        open={centerModal}
        editing={editingCenter}
        isAdmin={isAdmin}
        onClose={() => { setCenterModal(false); setEditingCenter(null); }}
        onSaved={refreshAll}
      />

      <AdminFacultyModal
        open={facultyModal}
        editing={editingFaculty}
        staffMembers={staff}
        onClose={() => { setFacultyModal(false); setEditingFaculty(null); }}
        onSaved={refreshAll}
      />

      <AdminFaqModal
        open={faqModal}
        editing={editingFaq}
        onClose={() => setFaqModal(false)}
        onSaved={refreshAll}
      />

      <AdminUserModal
        open={userModal}
        editing={editingUser}
        faculties={faculties}
        centers={centers}
        staffMembers={staff}
        onClose={() => setUserModal(false)}
        onSaved={refreshAll}
      />

      <AdminTenderModal
        open={tenderModal}
        editing={editingTender}
        isAdmin={isAdmin}
        onClose={() => { setTenderModal(false); setEditingTender(null); }}
        onSaved={refreshAll}
      />

      <AdminStaffModal
        open={staffModal}
        editing={editingStaff}
        onClose={() => { setStaffModal(false); setEditingStaff(null); }}
        onSaved={refreshAll}
      />

      <AdminSpecialProgramModal
        open={programModal}
        editing={editingProgram}
        faculties={faculties}
        onClose={() => { setProgramModal(false); setEditingProgram(null); }}
        onSaved={refreshAll}
      />

      <AdminKeyFactModal
        open={keyFactModal}
        editing={editingKeyFact}
        onClose={() => { setKeyFactModal(false); setEditingKeyFact(null); }}
        onSaved={refreshAll}
      />

      <AdminPartnerModal
        open={partnerModal}
        editing={editingPartner}
        onClose={() => { setPartnerModal(false); setEditingPartner(null); }}
        onSaved={refreshAll}
      />

      <AdminBroadcastModal
        open={broadcastModal}
        content={broadcastContent}
        onClose={() => { setBroadcastModal(false); setBroadcastContent(null); }}
      />
    </div>
  );
};